export default "__VITE_ASSET__BzI4bal9__"